/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_appsync_graphqlEndpoint": "https://2ss62glyefa2lbcqigrbinyarm.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://g17ftfzfj6.execute-api.eu-central-1.amazonaws.com/stage",
            "region": "eu-central-1"
        }
    ],
    "aws_cognito_identity_pool_id": "eu-central-1:36c005b6-93b2-4888-ad4e-a7f9581480fd",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_cSxVBv1J9",
    "aws_user_pools_web_client_id": "5radtbpbh2l4jsl3fs9l0o4jrf",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "anaabypp-20221209103650-hostingbucket-stage",
    "aws_content_delivery_bucket_region": "eu-central-1",
    "aws_content_delivery_url": "https://d1ma2m0824q20q.cloudfront.net",
    "aws_user_files_s3_bucket": "sanababyapp-storage130619-stage",
    "aws_user_files_s3_bucket_region": "eu-central-1",
    "img_proxy_base": "https://cms.stage-babyapp.sanamobil.de/storage",
};


export default awsmobile;
